import React from 'react'
import { Main } from './components'

const Suscription = () => <Main />

export default Suscription
